import { createFileRoute } from "@tanstack/react-router"
import CompanyProfileRevisionPage from "../../../../components/Settings/CompanyProfileRevisionPage"

export const Route = createFileRoute(
  "/_layout/company-settings/revisions/$revisionId",
)({
  component: CompanyProfileRevisionPage,
})
